import { DateRange } from '../../models/timeline-calendar.types';
import { useTranslation } from 'react-i18next';

interface TimelineNavigationProps {
  dateRange: DateRange;
  onPrevious: () => void;
  onNext: () => void;
  onToday: () => void;
}

export const TimelineNavigation = ({
  dateRange,
  onPrevious,
  onNext,
  onToday,
}: TimelineNavigationProps) => {
  void dateRange;
  const { t } = useTranslation();

  const arrowButtonStyle = {
    color: 'var(--color-text-tertiary)',
    backgroundColor: 'transparent',
  } as const;

  return (
    <div
      className="flex items-center gap-0.5 rounded-md px-0.5 py-0.5"
      style={{
        backgroundColor: 'var(--color-bg-app)',
        border: '1px solid var(--color-border)',
      }}
    >
      <button
        type="button"
        className="flex h-6 w-6 items-center justify-center rounded-sm text-xs transition-colors"
        style={arrowButtonStyle}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = 'var(--color-bg-hover)';
          e.currentTarget.style.color = 'var(--color-text-secondary)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = 'transparent';
          e.currentTarget.style.color = 'var(--color-text-tertiary)';
        }}
        onClick={onPrevious}
        title={t('period.previous')}
      >
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="15 18 9 12 15 6" />
        </svg>
      </button>

      <button
        type="button"
        className="rounded-sm px-2.5 py-0.5 text-[11px] font-medium transition-colors"
        style={{
          ...arrowButtonStyle,
          fontVariantNumeric: 'tabular-nums',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = 'var(--color-bg-hover)';
          e.currentTarget.style.color = 'var(--color-text-secondary)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = 'transparent';
          e.currentTarget.style.color = 'var(--color-text-tertiary)';
        }}
        onClick={onToday}
        title={t('period.backToToday')}
      >
        {t('period.today')}
      </button>

      <button
        type="button"
        className="flex h-6 w-6 items-center justify-center rounded-sm text-xs transition-colors"
        style={arrowButtonStyle}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = 'var(--color-bg-hover)';
          e.currentTarget.style.color = 'var(--color-text-secondary)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = 'transparent';
          e.currentTarget.style.color = 'var(--color-text-tertiary)';
        }}
        onClick={onNext}
        title={t('period.next')}
      >
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="9 18 15 12 9 6" />
        </svg>
      </button>
    </div>
  );
};
